import { useMemo } from 'react'

import { useQuery as useQueryDefault, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

/**
 * Hook to override or extend the react-query behavior
 */
export default function useQuery<TData = unknown, TError extends Error = Error>(
	querySettings: UseQueryOptions<TData, TError>
): UseQueryResult<TData, TError> & { isRefreshing: boolean } {
	const result = useQueryDefault<TData, TError>(querySettings)
	return useMemo(
		() => ({
			...result,
			isRefreshing: !result.isLoading && result.isFetching,
		}),
		[result]
	)
}
